import { render, staticRenderFns } from "./PaineisMenu.vue?vue&type=template&id=71b77643"
import script from "./PaineisMenu.vue?vue&type=script&lang=js"
export * from "./PaineisMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports